import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import GitHubLandingHelmet from 'common/helmets/GitHubLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import GitHubLogo from 'img/landing/canny-github-integration.webp';
import GitHub1 from 'img/landing/github-1.webp';
import GitHub2 from 'img/landing/github-2.webp';
import GitHub3 from 'img/landing/github-3.webp';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class GitHubLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed GitHub Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <GitHubLandingHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={GitHubLogo} />
              <div className="text">
                <h1 className="title">Canny for GitHub</h1>
                <div className="subtitle">Sync feedback between Canny and&nbsp;GitHub</div>
                <div className="links">
                  <InstallExtensionButton
                    installButtonText="Install GitHub"
                    installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fgithub"
                  />
                  <a
                    href="https://help.canny.io/en/articles/3481076-github-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={GitHub1} />
              </div>
              <div className="featureText">
                <div className="title">Link Canny posts with GitHub&nbsp;issues</div>
                <div className="subtitle">
                  Push issues from Canny to GitHub and link between the&nbsp;two.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={GitHub2} />
              </div>
              <div className="featureText">
                <div className="title">Access context in&nbsp;Canny</div>
                <div className="subtitle">
                  From a GitHub issue, use the link from the Canny bot to revisit context in the
                  Canny&nbsp;post.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={GitHub3} />
              </div>
              <div className="featureText">
                <div className="title">Keep statuses in&nbsp;sync</div>
                <div className="subtitle">
                  No more worrying about losing track of status updates. Automatically change the
                  status of Canny posts when you close a GitHub&nbsp;issue.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({
    trackEvent: TrackEventContext,
    viewer: ViewerContext,
  }),
  hot,
)(GitHubLanding);
